import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const CustomerService = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 44 45" fill="none">
    <rect width="45" height="45" rx="10" fill="#5FCBA7"/>
    <path d="M23 10C16.831 10 11.8 15.031 11.8 21.2V22.6C10.26 22.6 9 23.86 9 25.4V28.2C9 29.74 10.26 31 11.8 31H14.6V24V22.6V21.2C14.6 16.5442 18.3442 12.8 23 12.8C27.6558 12.8 31.4 16.5442 31.4 21.2V22.6V24V31V32.4H25.677C25.5324 31.991 25.2647 31.6369 24.9107 31.3862C24.5567 31.1355 24.1338 31.0006 23.7 31C23.143 31 22.6089 31.2213 22.2151 31.6151C21.8212 32.0089 21.6 32.543 21.6 33.1C21.6007 33.6304 21.8021 34.141 22.1638 34.529C22.5254 34.917 23.0205 35.1538 23.5496 35.1918C23.5996 35.1972 23.6498 35.2 23.7 35.2H31.4C32.9303 35.2 34.2 33.9303 34.2 32.4V31C35.74 31 37 29.74 37 28.2V25.4C37 23.86 35.74 22.6 34.2 22.6V21.2C34.2 15.031 29.169 10 23 10Z" fill="#D1F5E9"/>
  </SvgIcon>
));

CustomerService.displayName = 'CustomerService';

export default CustomerService;
